import { UIIcon } from '@icons/index.js';
import { UIButton, UIText } from '@ui';

export default class IconButton extends UIButton {
  constructor({
    buttonClass = '',
    textClass = '',
    iconName,
    text = '',
    iconSize = 20,
    color = 'transparent',
    strokeColor = null,
    onClick = () => {},
    rightIcon = false,
    className = '',
  }) {
    super();
    this.setClass(
      `flex gap-2 rounded-lg m-0 py-2 px-3 inline-flex items-center cursor-pointer ${buttonClass}`,
    ).onClick(onClick);

    if (!iconName)
      throw new Error('IconButton requires either iconName or iconClass');

    const icon = new UIIcon(iconName, {
      color,
      size: iconSize,
      strokeColor,
      className,
    });

    const textElement = new UIText(text).setClass(textClass);

    if (text) {
      if (rightIcon) {
        this.add(textElement, icon);
        return;
      }
      this.add(icon, textElement);
    } else {
      this.add(icon);
    }
  }
}
